<table class="unterauftraege-table ansicht-phone">
  <tr *ngFor="let unterauftrag of unterauftraege"
      [class.anderesGeraet]="istAnderemGeraetZugeordnet(unterauftrag)"
      [class.abgeschlossen]="unterauftrag.Auftragsstatus == 90 || unterauftrag.Auftragsstatus == 81"
      [class.abgelehnt]="unterauftrag.Auftragsstatus == 91"
      [class.volle-palette]="unterauftrag.istVollePalette"
      [class.zugewiesen]="unterauftrag.Auftragsstatus < 90 && unterauftrag.istZugewiesen">

    <td class="col-info1" appClick (clicked)="onUnterauftragClicked(unterauftrag)">{{ unterauftrag.label}}</td>
    
    <td class="col-info2" appClick (clicked)="onUnterauftragClicked(unterauftrag)">{{ unterauftrag.Info2}}
      <div *ngIf="unterauftrag.status" class="palette-status-{{ unterauftrag.status }}">{{ unterauftrag.statusText }}</div>

      <div *ngIf="unterauftrag?.Zusatzdaten?.Hinweistext" class="hinweistext">{{ unterauftrag?.Zusatzdaten?.Hinweistext }}</div>

      <span class="voll-abgelehnt">Muss noch aus Lager geholt werden</span>
    </td>

    <td class="col-info3" appClick (clicked)="onUnterauftragClicked(unterauftrag)">{{ unterauftrag.Info3}}</td>

    <td class="col-zuweisen">
      <!-- Fertig -->
      <ion-icon *ngIf="unterauftrag.Auftragsstatus == 90 || unterauftrag.Auftragsstatus == 81"
                name="checkmark"
                class="auftragsstatus-90"></ion-icon>

      <ion-toggle
                  slot="end"
                  name="blueberry"
                  [ngModel]="unterauftrag.istZugewiesen"
                  *ngIf="isToggleAnzeigen(unterauftrag)"
                  (ionChange)="onAuftragZugewiesenChanged($event, unterauftrag)"></ion-toggle>

      <ion-label
                 slot="end"
                 class="geraet-label"
                 *ngIf="unterauftrag.istAnderemGraetZugewiesen && unterauftrag.Auftragsstatus < 90 && unterauftrag.Auftragsstatus != 81">{{ unterauftrag.Geraet}}</ion-label>

      <div class="debug-info">
        <!--  Auftragsstatus: 10, istAnderemGraetZugewiesen: false, Geraet: S1, istZugewiesen: false  -->
        Auftragsstatus: {{ unterauftrag.Auftragsstatus }},
        istAnderemGraetZugewiesen: {{ unterauftrag.istAnderemGraetZugewiesen }},
        Geraet: {{ unterauftrag.Geraet }},
        istZugewiesen: {{ unterauftrag.istZugewiesen }}
      </div>
    </td>
  </tr>
</table>